<template>
  <div id="system-manage-authority">
    <div class="ipub-h1 mar-b-30">Manage Authority</div>
    <ipub-row :gutter="60">
      <ipub-col :span="3">
        <site-search-group class="mar-b-16"
                           v-model.trim="params.name"
                           placeholder="Search by authority"
                           :clear="false"
                           @search="getRoles" />
        <ipub-menus class="mar-b-20 system-manage-authority-aside"
                    v-if="roles && roles.length">
          <div :class="['mar-b-4' ,'ipub-p2', 'system-manage-authority-aside-item',path.includes(item.id)?'active':'']"
               v-for="(item, index) in roles"
               :key="'system-manage-authority-aside-item'+index">
            <!-- <ipub-menus-item> -->
            <div class="manage-authorit-item">
              <div class="manage-authorit-item__content omis"
                   :style="item.type==='OTHER'?'':'width:100%'">
                <router-link :to="'/system/manage-authority/'+item.id">{{item.journal && item.journal.name}} {{item.name}}</router-link>
              </div>
              <div class="manage-authorit-item__action"
                   v-if="item.type==='OTHER'">
                <ipub-icon type="iconEdit"
                           @click="edit(item)" />
                <ipub-icon type="iconDelete"
                           @click="del(item)" />
              </div>
            </div>
            <!-- </ipub-menus-item> -->
          </div>
        </ipub-menus>
        <div style="display: flex; flex-direction: column;">
          <ipub-button class="ipub-p1 line-h-40 mar-b-12"
                       style="width:100%"
                       type="primary"
                       @click="add">
            Create a New Role
          </ipub-button>

          <ipub-button class="ipub-p1 line-h-40"
                       style="width:100%; margin-left: 0;"
                       type="primary"
                       @click="addJournalRole">
            Create a New Journal Role
          </ipub-button>
        </div>

      </ipub-col>
      <ipub-col :span="9">
        <router-view></router-view>
      </ipub-col>
    </ipub-row>
    <Add ref="manage-authority-add"
         :isVisable="isVisable"
         @confirm="confirm"
         @cancel="cancel" />
    <AddJournalDialog
      ref="manage-authority-add-journal"
      :is-visable="isVisableJournal"
      @confirm="confirmJournal"
      @cancel="cancelJournal"
    />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
